// const MAIN_URL = "https://commonthreadsapidev.herokuapp.com/api"; // DEV
const MAIN_URL = "https://commonthreadsapi.herokuapp.com/api"; // PROD

export { MAIN_URL };
